import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function OpeningHook() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-light py-16 md:py-24 border-y border-white/5" data-id="element-102">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 space-y-6 text-gray-200 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-103">
        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-104">
          Si eres como la mayoría de los latinos en Estados Unidos, trabajas
          duro, pagas tus impuestos a tiempo y confías en que tu preparador de
          taxes está haciendo lo mejor por ti.
        </p>

        <p className="text-xl md:text-2xl leading-relaxed font-semibold text-white" data-id="element-105">
          Pero hay una verdad incómoda que nadie te dice:
        </p>

        <p className="text-xl md:text-2xl leading-relaxed" data-id="element-106">
          La mayoría de los preparadores solo llenan formas. No son estrategas.
          No buscan "vacíos" legales. Solo quieren terminar rápido para cobrarte
          su tarifa y pasar al siguiente cliente.
        </p>

        <div className="bg-navy-dark p-6 md:p-8 rounded-xl border border-gold-primary/20 mt-8 shadow-lg" data-id="element-107">
          <p className="text-xl md:text-2xl leading-relaxed text-gold-light font-medium" data-id="element-108">
            ¿El resultado? Estás dejándole una "propina" gigante al Tío Sam cada
            año. Dinero que te pertenece. Dinero que podría pagar tu renta, tu
            carro o el fondo universitario de tus hijos.
          </p>
        </div>
      </div>
    </section>;
}